import { ACCOUNT_AFTER_CHANGE_EMAIL_LINK } from '~shared/constants/links.constants';
import { APP_AUTH_ROUTE, APP_EMPLOYEE_CUSTOMERS_LIST } from '~shared/constants/routes.constants';

export const SIMPLIFIED_FOOTER_URLS = [
  APP_AUTH_ROUTE,
  ACCOUNT_AFTER_CHANGE_EMAIL_LINK,
  `/${APP_EMPLOYEE_CUSTOMERS_LIST}`
];
